export default __webpack_public_path__ + "static/media/Clínica-da-Mulher.ef7202ca.png";